import Backbone from 'backbone'
import template from './trees-test.hbs'
import TestGardener from '../../tests/scoreboard/components/test-gardener'
import ObjectSelector from 'scoreboard/components/object-selector'
import defaultDialog from './default-dialog.hbs'
import appDisplay from 'scoreboard/components/app-display'
import resizeDialogContent from 'scoreboard/components/resize-dialog-content'

var TreeDialog = Backbone.View.extend({
	className: 'tree-dialog',

	events: {
		'click .done': 'done'
	},

	initialize: function({ content, title } = {}) {
		this.title = title || 'Tree Dialog'
	},

	render: function() {
		this.$el.empty().append(defaultDialog({
			title: this.title,
			content: this.content
		}))

		this.dialogTree = new TestGardener({ id: 1, section: 'files', lightTree: true })
		this.$('.test-dialog-container').append(`
			<div class="panel" style="height: 400px;"></div>
		`)
		this.$('.panel').append(this.dialogTree.el)
		this.dialogTree.render()
		this.dialogTree.show().startStream()

		return this
	},

	resize(maxHeight) {
		resizeDialogContent({
			dialog: this.el,
			maxHeight,
			target: this.$('.panel')
		})
	},

	done: function() {
		this.trigger('done')
	}
})

var TreeTestView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-trees',

	render: function () {
		this.$el.empty().append(template())

		this.defaultTree = new TestGardener({ id: 1, section: 'files', lightTree: true })
		this.$('.default-tree-panel .panel-content').append(this.defaultTree.render().el)
		this.defaultTree.show().startStream()

		this.objectSelector = new ObjectSelector({
			orgId: 1,
			section: 'scorecards',
			preventStandardExpand: true
		})

		this.$('.object-selector-panel .panel-content').append(this.objectSelector.render().el)

		// Setup loading dot test buttons
		this.$('.default-tree-panel .loading-dots-button').click(() => {
			if (this.defaultTreeLoading) {
				this.defaultTree.clearLoadingDots()
				this.defaultTreeLoading = false
			} else {
				this.defaultTree.insertLoadingDots()
				this.defaultTreeLoading = true
			}
		})

		this.$('.object-selector-panel .loading-dots-button').click(() => {
			if (this.objectTreesLoading) {
				this.objectSelector.orgGardener.clearLoadingDots()
				this.objectSelector.objectGardener.clearLoadingDots()
				this.objectTreesLoading = false
			} else {
				this.objectSelector.orgGardener.insertLoadingDots()
				this.objectSelector.objectGardener.insertLoadingDots()
				this.objectTreesLoading = true
			}
		})

		this.$('button.tree-in-dialog').on('click', () => {
			appDisplay.dialog(new TreeDialog())
		})
		return this
	}
})

export default TreeTestView
